/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Input } from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the selection of products
 */
class SelectorSex extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            options: [], // The options to fill the selection
            sex: this.props.data.sex
        };
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     * @param event The event (on change)
     */
    handleChange = (event) => {
        this.setState({value: event.target.value}, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
            <Input type="select" className="form-control" name="sex" onChange={this.handleChange} value={this.props.value}>
                <option key={""} value={""}>
                    <Translate id="profile-register.select-sex" options={{renderInnerHtml: false}}/>
                </option>
                <option key={"F"} value={"F"}>
                    <Translate id="profile-register.female" options={{renderInnerHtml: false}}/>
                </option>
                <option key={"M"} value={"M"}>
                    <Translate id="profile-register.male" options={{renderInnerHtml: false}}/>
                </option>
                <option key={"O"} value={"O"}>
                    <Translate id="profile-register.other" options={{renderInnerHtml: false}}/>
                </option>
                <option key={"U"} value={"U"}>
                    <Translate id="profile-register.unknown" options={{renderInnerHtml: false}}/>
                </option>
            </Input>
        )
    }
}

export default SelectorSex;


// WEBPACK FOOTER //
// ./src/components/selectors/selector-sex.js